import Typography from '@mui/material/Typography';
import { formatNumber } from '@shared/ui/Number';
import { formatDate } from '@shared/utils/date';
import Avatar from '@/component/Avatar/Avatar';
import { Flex } from '@/component/Flex';
import { Parameter, ParameterList } from '@/component/ParameterList';
import Translate from '@/component/Translate';
import { useTexts } from '@/feature/lang/hook';
import { useCurrentUser } from '@/feature/user/queries';
import { ContentContainer } from '../components/ContentContainer';
import { Section } from '../components/Section';
import ChangePassword from './ChangePassword';
import { sectionSize } from './layout';

interface PersonalInfoProps {
  visible: boolean;
}

const PersonalInfo = ({ visible }: PersonalInfoProps) => {
  const { firstName, lastName, image, email } = useCurrentUser();
  const texts = useTexts().user.preferences;
  const userModelTexts = useTexts().admin.user.model;

  return (
    <ContentContainer visible={visible}>
      <Section>
        <Flex flexFlow="column nowrap" gap={2}>
          <Avatar
            firstName={firstName}
            lastName={lastName}
            profileImage={image}
            size="xl"
          />
          <Typography variant="h2">
            <Translate text={texts.welcome} values={{ firstName, lastName }} />
          </Typography>
        </Flex>
      </Section>
      <Section>
        <ParameterList
          title={texts.personalInfo.contact}
          keyColumnWidth={sectionSize.keyColumnWidth}
          fullWidth
        >
          <Parameter label={userModelTexts.firstName} value={firstName} />
          <Parameter label={userModelTexts.lastName} value={lastName} />
          <Parameter label={userModelTexts.email} value={email} />
        </ParameterList>
      </Section>
      <Section>
        <ChangePassword />
      </Section>
      <DisplayFormatSection />
    </ContentContainer>
  );
};

export default PersonalInfo;

const DisplayFormatSection = () => {
  const texts = useTexts().user.preferences.personalization;

  return (
    <Section>
      <ParameterList
        title={texts.displayFormat}
        keyColumnWidth={sectionSize.keyColumnWidth}
        fullWidth
      >
        <Parameter
          label={texts.displayFormat.numbers}
          value={formatNumber(1234.56, { fractionDigits: 2 }) ?? ''}
        />
        <Parameter
          label={texts.displayFormat.dates}
          value={formatDate(new Date())}
        />
      </ParameterList>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', px: 1, py: 0.5 }}
      >
        <Translate text={texts.displayFormat.hint} />
      </Typography>
    </Section>
  );
};
